import {setCookie} from "./utils/setCookie";

(function () {
    let inited = false;

    initSlider();
    window.addEventListener('resize', initSlider);

    function initSlider() {
        let $slider = $('.french-themes-mobile-js');
        if(window.innerWidth > 600){
            $slider.trigger('destroy.owl.carousel');
            inited = false;
            return;
        }

        if(inited)
            return;

        $slider.owlCarousel({
            items: 1,
            nav: true,
            navText: ['', ''],
        });
    }
})();

window.addEventListener('scroll', function () {
    let ids = [
        'for-whom', 'lesson-format', 'timing', 'method', 'teachers', 'french-bref', 'team',
    ];
    let activeId = null;
    let documentHeight = document.documentElement.clientHeight;

    for(let id of ids) {
        let block = document.getElementById(id);
        if(!block)
            continue;
        let topY = block.offsetTop;
        let bottomY = block.offsetTop + block.offsetHeight;
        let currentCenterY = pageYOffset + documentHeight / 2;
        if(currentCenterY > topY && currentCenterY < bottomY)
            activeId = id;
    }

    $('#top-js .menu-item a').removeClass('active');
    if(activeId)
        $(`#top-js .menu-item a[href='#${activeId}']`).addClass('active');
});
window.dispatchEvent(new CustomEvent('scroll'));

$('#lang-select-js').change(function () {
    setCookie('lang', this.value, {
        expires: new Date((new Date()).getTime() + 86400 * 1000 * 365),
    });
    document.location.reload();
});